import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LocationIcon from "../../../assets/img/svg/location.svg";
import { getReportUserDetails } from "../../../redux/action/admin/AdminAcountsAction";
import { withRouter } from "react-router-dom";
import ErrorMessage from "../../common/ErrorMessage";
import BubblesLoader from "../../common/BubblesLoader";

const UserReportViewBox = ({ match, history }) => {
  const { jobId } = match.params;
  const userReportDetails = useSelector(
    (state) => state.AdminAcountsReducer.userReportDetails
  );
  const viewId =
    userReportDetails &&
    userReportDetails.user_details &&
    userReportDetails.user_details.id;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(getReportUserDetails(setLoading, setError, jobId));
  }, [dispatch, setLoading, jobId]);

  return (
    <>
      {error !== "" ? <ErrorMessage message={error} /> : ""}
      {loading ? (
        <div className="h-100 d-flex justify-content-center align-items-center flex-column">
          <BubblesLoader />
          <p className="pt-3 common-heading-Medium  f-w-600 text-black md-font">
            Please wait...
          </p>
        </div>
      ) : (
        <>
          <div className="row  pb-4 br-bottom">
            <div className="col-xxl-4 col-sm-6  d-flex justify-content-xxl-start justify-content-center pb-3">
              <img
                className="profile-upload w-100 br-10"
                alt=""
                src={
                  userReportDetails &&
                  userReportDetails.user_details &&
                  userReportDetails.user_details.profile_image_path
                }
              />
            </div>
            <div className="col-xxl-4 col-sm-6  pt-1 my-auto d-flex justify-content-between  align-items-xxl-start align-items-center ">
              <div>
                <div className="  mb-2  ">
                  <p className="common-heading">
                    {userReportDetails &&
                      userReportDetails.user_details &&
                      userReportDetails.user_details.first_name}{" "}
                    {userReportDetails &&
                      userReportDetails.user_details &&
                      userReportDetails.user_details.last_name}
                  </p>
                </div>
                <div className="mb-2 d-flex">
                  <span>
                    <img className="pe-3" src={LocationIcon} alt="location" />
                  </span>
                  <p className="common-text">
                    {userReportDetails &&
                      userReportDetails.user_details &&
                      userReportDetails.user_details.city}
                    ,
                    {userReportDetails &&
                      userReportDetails.user_details &&
                      userReportDetails.user_details.country}
                  </p>
                </div>
              </div>
              <div>
                <div className="mb-2">
                  <p className="common-heading">
                    {userReportDetails && userReportDetails.total_reports}
                  </p>
                </div>
                <div className="mb-2">
                  <p className="common-text f-w-600">Total Reports</p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 mt-2 mt-sm-0 ">
              <div className="d-flex flex-sm-row flex-column  justify-content-center justify-content-sm-end">
                <button
                  className="py-2 px-2 atech-primary-button  mt-2 mt-sm-0 me-sm-2"
                  onClick={() =>
                    history.push(
                      `/admin/${
                        userReportDetails &&
                        userReportDetails.user_details &&
                        userReportDetails.user_details.is_creator === true
                          ? "creator"
                          : "client"
                      }/profile/${viewId}`
                    )
                  }
                >
                  View Profile
                </button>
              </div>
            </div>
          </div>

          {/* ====================================Bio-section===================================== */}
          <span className="border-bottom d-block "></span>
          <div className="row">
            <div className="col-12 pb-4  br-bottom">
              <p className="mt-4 common-heading-Medium  sm-font">
                Why user is reported ?
              </p>
              <p className="common-text ">
                {userReportDetails && userReportDetails.reason}
              </p>
              <p className="common-text ">
                {userReportDetails && userReportDetails.description}
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default withRouter(UserReportViewBox);
